export const TOGGLE_VM_EXTEND = "TOGGLE_VM_EXTEND";

export const toggleVMExtend = (isVMExtended) => ({
    type: TOGGLE_VM_EXTEND,
    payload: isVMExtended,
}); 